import type { ReactNode } from "react";

import "./ui.css";

interface FilterBarProps {
  children: ReactNode;
  actions?: ReactNode;
}

export function FilterBar({ children, actions }: FilterBarProps) {
  return (
    <div className="filter-bar">
      <div className="filter-bar__group">{children}</div>
      {actions && <div className="filter-bar__actions">{actions}</div>}
    </div>
  );
}
